__turbopack_context__.v({
  "className": "ibm_plex_sans_arabic_193e8739-module__7kuaAq__className",
  "variable": "ibm_plex_sans_arabic_193e8739-module__7kuaAq__variable",
});
